function Footer() {
  return (
    <footer className="bg-white border-t mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center text-gray-600">
          <p>
            © 2025 Math Games Hub. Making mathematics fun and accessible for
            everyone.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
